const idFlag = require('./assets/images/ind_flag.svg')
const usFlag = require('./assets/images/us_flag.svg')

export default {
  languages: [
    {
      text: 'IND',
      value: 'in_ID',
      flag: idFlag,
    },
    {
      text: 'EN',
      value: 'en_US',
      flag: usFlag,
    },
  ],

  links: {
    instagram: 'http://www.instagram.com/oscarartunes/',
    facebook: 'http://www.facebook.com/oscarartunes.ranuhandoko',
  },

  icons: {
    chevron: 'mdi-chevron-up',
    home: 'mdi-home',
    image: 'mdi-image',
    email: 'mdi-email',
    instagram: 'mdi-instagram',
    facebook: 'mdi-facebook',
    featured: "mdi-image-album"
  },
}
